import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import Toggle from "../../../../common/AdminCommonComponents/Toggle/Toggle"
import { MdOutlineEdit } from "react-icons/md"

const OtherPlatformFees = ({ onClick }) => {
  const data = [
    {
      feeType: "Transaction Type",
      feeName: ["Standard Orders", "High-Volume Orders", "Returns and Refunds"],
      amount: ["Category fee + $0.50", "Category fee + $0.50", "$2"],
      conditions: ["Per order", "Per order", "Per order"],
      applicableTo: ["All Sellers", "All Sellers", "All Sellers"],
      status: [<Toggle />, <Toggle />, <Toggle />],
    },
    {
      feeType: "Ad Type",
      feeName: ["Sponsored Products", "Sponsored Brands", "Sponsored display", "Banner Ads", "Video Ads", "Blog Ads"],
      amount: ["$0.50", "$1.00", "$0.50 / $2.00", "$2.00", "$0.50 / $2.00", "$0.50 / $2.00"],
      conditions: ["PPC", "PPC", "PPC / CPM", "CPM", "PPC / CPM", "PPC / CPM"],
      applicableTo: ["All Sellers", "All Sellers", "All Sellers", "All Sellers", "All Sellers", "All Sellers"],
      status: [<Toggle />, <Toggle />, <Toggle />, <Toggle />, <Toggle />, <Toggle />],
    },
    {
      feeType: "FBM Fee",
      feeName: ["Standard Shipping", "Express Shipping", "Storage Fees", "Handling Fees"],
      amount: ["$5", "$10", "$0.50", "$1"],
      conditions: ["Per order", "Per order", "per cubic foot/month", "per item"],
      applicableTo: ["All Sellers", "All Sellers", "All Sellers", "All Sellers"],
      status: [<Toggle />, <Toggle />, <Toggle />, <Toggle />],
    },
    {
      feeType: "Service type",
      feeName: ["Account Review", "Custom Report", "Portal access", "Portal access"],
      amount: ["$20", "$5", "$30", "$35"],
      conditions: ["$20 per review", "Per report", "Monthly", "Monthly"],
      applicableTo: ["All Sellers", "All Sellers", "Only Sellers", "Only Retailers"],
      status: [<Toggle />, <Toggle />, <Toggle />, <Toggle />],
    },
  ]

  const cols = [
    {
      name: "Fee Type",
      cell: (row) => row.feeType,
      style: {
        backgroundColor: "#FDE1A4",
      },
    },
    {
      name: "Fee Name",
      cell: (row) => (
        <ul className="list-unstyled m-0 d-flex flex-column gap-2">
          {row.feeName.map((name, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      ),
      style: {
        backgroundColor: "#EAEAEA",
      },
    },
    {
      name: "Amount",
      cell: (row) => (
        <ul className="list-unstyled m-0 d-flex flex-column gap-2">
          {row.amount.map((amt, index) => (
            <li key={index}>{amt}</li>
          ))}
        </ul>
      ),
      style: {
        backgroundColor: "#D3FFCD",
      },
    },
    {
      name: "Conditions",
      cell: (row) => (
        <ul className="list-unstyled m-0 d-flex flex-column gap-2">
          {row.conditions.map((cond, index) => (
            <li key={index}>{cond}</li>
          ))}
        </ul>
      ),
      style: {
        backgroundColor: "#CDF9FF",
      },
    },
    {
      name: "Applicable To",
      cell: (row) => (
        <ul className="list-unstyled m-0 d-flex flex-column gap-2">
          {row.applicableTo.map((app, index) => (
            <li key={index}>{app}</li>
          ))}
        </ul>
      ),
      style: {
        backgroundColor: "#CDDEFF",
      },
    },
    {
      name: "Status",
      cell: (row) => (
        <ul className="list-unstyled m-0 d-flex flex-column gap-2">
          {row.status.map((toggle, index) => (
            <li key={index}>{toggle}</li>
          ))}
        </ul>
      ),
      center: "true",
      style: {
        backgroundColor: "#F7FDAE",
      },
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex flex-column">
          {Array.from({ length: row.feeName.length }).map((_, index) => (
            <button style={{ all: "unset", cursor: 'pointer' }}>
              <MdOutlineEdit key={index} size={24} />
            </button>
          ))}
        </div>
      ),
      center: "true",
    },
  ]

  return (
    <>
      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow">
        <div className="fw-semibold fs-5">Platform Fees</div>
        <DynamicButton theme="blue" onClick={() => onClick(prev => !prev)}>
          Add new fee
        </DynamicButton>
      </div>

      <DynamicDatatable data={data} columns={cols} type="yellow" />
    </>
  )
}

export default OtherPlatformFees
